<template>
<div class="chapter">
<div class="inner_page">
<p class="sert">And again…</p>
<p class="ser2">To</p>
<p class="ser">George MacDonald</p>
<p class="ser">and</p>
<p class="ser">C.S. Lewis…</p>
<p class="ser2">worthy mentors with broad shoulders</p>
<p class="ser">who paved the way.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hell_and_Beyond_Split3.vue?136199d9